import { render, staticRenderFns } from "./HeaderNavigation.vue?vue&type=template&id=ebd58738&scoped=true&"
import script from "./HeaderNavigation.vue?vue&type=script&lang=ts&"
export * from "./HeaderNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderNavigation.vue?vue&type=style&index=0&id=ebd58738&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd58738",
  null
  
)

export default component.exports